
import userMixins from "~/plugins/userMixins";
export default {
  mixins: [userMixins],
  props: ["noTitle","hasStores"],
};
